import axios from 'axios';
import API_CONFIG from '../config/api';
import { translateVi } from '../i18n/LocaleContext';

const API_URL = API_CONFIG.getApiUrl(API_CONFIG.ENDPOINTS.SOCIAL);

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

export const socialService = {
  getAccounts: async () => {
    try {
      const response = await axios.get(API_URL, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể tải danh sách tài khoản'));
    }
  },

  bind: async (platform, accountUrl) => {
    try {
      const response = await axios.post(API_URL, { platform, account_url: accountUrl }, getAuthHeader());
      return response.data;
    } catch (error) {
      const err = new Error(error.response?.data?.error || translateVi('Không thể gửi yêu cầu liên kết'));
      err.errorCode = error.response?.data?.errorCode;
      throw err;
    }
  }
};
